import React from 'react'
/* import Link from 'gatsby-link' */
import Header from '../components/Header'
import ProjectsGrid from '../components/Projects-grid'
import Footer from '../components/Footer'



const IndexPage = () => (
    <div>
        <div className="computer">
                <div className="hero">
                    <form style={{display: 'none'}} name="secret" method="post">
                        <label className="form-children">Name<br/><input name="name" type="text"></input></label>
                        <label className="form-children">Email<br/> <input name="email" type="email"></input></label>
                        <label className="form-children">Message<br/> <textarea name="message"></textarea></label>
                        <input value="Send" className="form-children" type="submit" className="blue-button" style={{height: '45.2px'}}></input>
                    </form>
                    <Header />

                    <div className="container hero-container">
                        <h1 style={{marginBottom: '10px', marginTop: '10px'}}>I build websites that build businesses.</h1>
                        <p style={{color: 'white', }}>Whether you are looking for a simple one-page website, or a large ecommerce site, I'll create a fast, beautiful website that will help build your business.</p>
                        <a href="#contact"><button className="blue-button" style={{marginTop: '10px'}}><p>Get in touch</p></button></a>
                    </div>

                </div>

                <div className="container intro-copy">
                    <div className="intro-copy-text">
                        <h2>How can I help you?</h2>
                        <p>Having spent many years in digital marketing and search engine optimisation before I became a developer I understand how to build a commercially successful website.
                        </p>
                        <p>I'll build you a site that works flawlessly on all devices, loads quickly and engages and converts your customers.</p>
                        <a href="#contact"><button className="blue-button" style={{marginTop: '10px'}}><p>Get in touch</p></button></a>
                    </div>
                </div>

                
        </div>
        <div className="container projects">
            <h2 style={{marginTop: '40px'}}>Work.</h2>
            <ProjectsGrid/>
        </div>

        <div style={{marginTop: '40px', background: 'linear-gradient(to right, #000046, #168F98, #1CB5E0)'}}>
            <div className="container" id="contact">
                <h2 style={{paddingTop: '40px', color: 'white', textAlign: 'center'}}>Let's talk about your project.</h2>

                <form name="contact" method="post" data-netlify="true" data-netlify-honeypot="bot-field">
                    <label style={{display:'none'}} className="form-children"><br/><input name="bot-field" type="text"></input></label>
                    <label className="form-children">Name<br/><input name="name" type="text"></input></label>
                    <label className="form-children">Email<br/> <input name="email" type="email"></input></label>
                    <label className="form-children">Message<br/> <textarea name="message"></textarea></label>
                    <div className="form-children" data-netlify-recaptcha></div>
                    <input value="Send" className="form-children" type="submit" className="blue-button" style={{height: '45.2px'}}></input>
                </form>


            

            </div>

        </div>
        <Footer />
        
    </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js